import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { debounce } from "lodash";
import useConstant from "use-constant";

// Redux
import usePermissions from "../../redux/selectors/usePermissions";

// Formik
import { Formik, Form, Field } from "formik";
import { TextField, CheckboxWithLabel } from "formik-mui";

// Custom
import Select from "../../components/FormikFields/Select";
import ButtonGroup from "../../components/Buttons/ButtonGroup";
import { courseTypes } from "../../constants";

// Material UI
import { Button, Collapse, Grid, InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { ArrowDropDown, ArrowDropUp } from "@mui/icons-material";

const SpecialAssignmentsFilters = ({ onSubmit }) => {
  const { t } = useTranslation();
  const { hasPolicyPartnerAdminAccess } = usePermissions();
  const [filterMenuExpanded, setFilterMenuExpanded] = useState(false);
  const types = [
    { label: courseTypes.online, value: "online" },
    { label: courseTypes.instructorLedTraining, value: "ilt" }
  ];
  if (hasPolicyPartnerAdminAccess) {
    types.push({ label: courseTypes.policy, value: "policy" });
  }

  const initialValues = {
    searchName: "",
    type: "",
    hideAssignments: false
  };

  return (
    <Formik
      initialValues={initialValues}
      enableReinitialize
      onSubmit={onSubmit}
    >
      {({ submitForm, handleReset }) => {
        const debouncedSubmit = useConstant(() => debounce(submitForm, 500));
        return (
          <Form>
            <Grid container sx={{ alignItems: "center", mt: 1.5 }} spacing={3}>
              <Grid item xs={12} md={10}>
                <Field
                  fullWidth
                  label={t("specialAssignments.searchName")}
                  variant="filled"
                  component={TextField}
                  name="searchName"
                  onKeyUp={debouncedSubmit}
                  type="text"
                  disabled={false}
                  InputProps={{
                    disableUnderline: true,
                    endAdornment: (
                      <InputAdornment position="end">
                        <SearchIcon />
                      </InputAdornment>
                    )
                  }}
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <Button
                  color="primary"
                  endIcon={
                    filterMenuExpanded ? <ArrowDropUp /> : <ArrowDropDown />
                  }
                  onClick={() =>
                    setFilterMenuExpanded(
                      filterMenuExpanded => !filterMenuExpanded
                    )
                  }
                >
                  {t("employeesFilters.showFilters")}
                </Button>
              </Grid>
            </Grid>
            <Collapse in={filterMenuExpanded}>
              <>
                <Grid
                  container
                  spacing={4}
                  sx={{ alignItems: "center", mt: 0 }}
                >
                  <Grid item xs={12} md={4}>
                    <Select
                      name="type"
                      menuItems={types}
                      label={t("specialAssignments.type")}
                      disableUnderline
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Field
                      component={CheckboxWithLabel}
                      disabled={false}
                      name="hideAssignments"
                      Label={{
                        label: t("specialAssignments.hidePastAssignments")
                      }}
                      color="primary"
                      type="checkbox"
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <ButtonGroup>
                      <Button
                        color="primary"
                        onClick={() => {
                          handleReset();
                          submitForm();
                        }}
                      >
                        {t("clearAllBtn")}
                      </Button>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={submitForm}
                      >
                        {t("filterList")}
                      </Button>
                    </ButtonGroup>
                  </Grid>
                </Grid>
              </>
            </Collapse>
          </Form>
        );
      }}
    </Formik>
  );
};

export default SpecialAssignmentsFilters;
